module.exports = __webpack_public_path__ + "img/img9.283e959f.jpg";